import { hellopanda_func as $ } from '../../../assets/script/func.js';

/**
 * SMOOTHWHEEL — 최적화 버전
 */
const HELLOPANDA_SMOOTHWHEEL = {

  resizeSet: new Set(),
  resizeWidth: window.innerWidth,
  resizeHeight: window.innerHeight,
  resizeHeightAllow: $.resizeHeightAllow,

  block: null,
  isEnabled: false,
  isScrolling: false,
  currentScroll: 0,
  targetScroll: 0,
  deltaY: 0,
  ease: 0.1,
  tick: 0.5,
  mobilesize: 780,
  maxScroll: 0,
  _wheelHandler: null,
  _resizeHandler: null,
  _mutationObserver: null,
  _smoothScrollHandler: null, // bind 재사용

  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  },

  init() {
    const _ = this;

    document.addEventListener('DOMContentLoaded', () => {
      const block = document.querySelector('.wp-block-hellopanda-smoothwheel-block');
      if (!block || block.dataset.smoothwheelDisable) return;

      this.block = block;
      this._smoothScrollHandler = this._smoothScroll.bind(this);

      this.evaluateEnvironment();

      // 구독형 리사이즈
      const handleResize = _.debounce(() => {
        if (_.checkResize()) {
          _.resizeNotify();
        }
      }, 300);
      window.addEventListener('resize', handleResize.bind(this));

      _.resizeSubscribe(() => {
        this.evaluateEnvironment();
      });

      // DOM 변경 감시
      this.installObservers();
    });
  },

  checkResize() {
    const _ = this;
    const w = window.innerWidth;
    const h = window.innerHeight;
    let changed = false;

    if (w !== _.resizeWidth) {
      _.resizeWidth = w;
      changed = true;
    } else if (Math.abs(h - _.resizeHeight) >= _.resizeHeightAllow) {
      _.resizeHeight = h;
      changed = true;
    }

    return changed;
  },

  resizeNotify() {
    this.resizeSet.forEach(fn => fn(this.resizeWidth, this.resizeHeight));
  },

  resizeSubscribe(fn) {
    this.resizeSet.add(fn);
    return () => this.resizeSet.delete(fn);
  },

  evaluateEnvironment() {
    if (!this.block) return;

    const isMobile = $.isDeviceMobile() || window.innerWidth <= this.mobilesize;

    if (isMobile) {
      if (this.isEnabled) this.disable('environment: mobile or cannot activate');
    } else {
      if (!this.isEnabled) this.enable(this.block);
    }
  },

  enable(block) {
    if (this.isEnabled || !block) return;

    this.block = block;
    this.ease = parseFloat(block.dataset.smoothwheelEase) || 0.1;
    this.tick = parseFloat(block.dataset.smoothwheelTick) || 0.5;
    this.currentScroll = window.scrollY;
    this.targetScroll = window.scrollY;
    this.isScrolling = false;

    this.maxScroll = document.body.scrollHeight - window.innerHeight;

    // wheel 이벤트
    this._wheelHandler = this._onWheel.bind(this);
    window.addEventListener('wheel', this._wheelHandler, { passive: false });

    // 브라우저 기본 스크롤 처리
    if (block.dataset.smoothwheelBrowser) {
      document.documentElement.style.scrollBehavior = 'smooth';
    }

    this.isEnabled = true;
    // console.log('SmoothWheel enabled');
  },

  disable(reason) {
    if (!this.isEnabled) return;

    if (this._wheelHandler) {
      window.removeEventListener('wheel', this._wheelHandler, false);
      this._wheelHandler = null;
    }

    this.isScrolling = false;
    this.isEnabled = false;
    // console.log('SmoothWheel disabled:', reason || '');
  },

  _onWheel(e) {
    const nearest = this._nearestScrollableAncestor(e.target);
    const root = document.scrollingElement || document.documentElement;
    if (nearest && nearest !== root && nearest !== document.body && nearest !== document.documentElement) return;

    e.preventDefault();

    // deltaY 제한 (너무 큰 값 방지)
    this.deltaY = Math.max(-100, Math.min(e.deltaY, 100));

    if (!this.isScrolling) {
      this.currentScroll = window.scrollY;
      this.targetScroll = window.scrollY;
    }

    this.targetScroll += this.deltaY;

    if (!this.isScrolling) {
      this.isScrolling = true;
      requestAnimationFrame(this._smoothScrollHandler);
    }
  },

  _smoothScroll() {
    // maxScroll 캐시 사용
    const maxScroll = this.maxScroll = Math.max(this.maxScroll, document.body.scrollHeight - window.innerHeight);
    this.targetScroll = Math.max(0, Math.min(this.targetScroll, maxScroll));

    if (this.targetScroll >= maxScroll && this.deltaY > 0) this.targetScroll += 50;
    else if (this.targetScroll <= 0 && this.deltaY < 0) this.targetScroll -= 50;

    this.currentScroll += (this.targetScroll - this.currentScroll) * this.ease;
    window.scrollTo(0, this.currentScroll);

    if (Math.abs(this.targetScroll - this.currentScroll) > this.tick) {
      requestAnimationFrame(this._smoothScrollHandler);
    } else {
      this.currentScroll = this.targetScroll;
      this.isScrolling = false;
    }
  },

  _isElementScrollable(el) {
    if (!el || el.nodeType !== 1) return false;
    const style = getComputedStyle(el);
    const overflowY = (style.overflowY || '').toLowerCase();
    return /(auto|scroll|overlay)/.test(overflowY) && el.scrollHeight > el.clientHeight + 1;
  },

  _nearestScrollableAncestor(el) {
    if (!el) return null;
    let cur = el.nodeType === 1 ? el : el.parentElement;
    while (cur && cur !== document.documentElement) {
      if (this._isElementScrollable(cur)) return cur;
      cur = cur.parentElement;
    }
    return null;
  },

  installObservers() {
    if (!('MutationObserver' in window)) return;

    const _ = this;
    const evaluate = _.debounce(() => this.evaluateEnvironment(), 300);

    this._mutationObserver = new MutationObserver(evaluate);
    this._mutationObserver.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
  },

};

HELLOPANDA_SMOOTHWHEEL.init();